import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Typography, Button, Checkbox } from "antd";

import "Assets/styles/default/components/Modal/ModalPopBallonStyles.less";
import { CloseOutlined, LeftOutlined } from "@ant-design/icons";
import Terms from "components/Terms/Terms";
import { LegalText } from "components/PopBallon/ShowcasePopBallon/BallonModal";
import { signTerm } from "redux/Reducers/PopBallon/VertemGiftApi";
import { VertButton } from "@vertem-core/vertice-ds";

const { Paragraph } = Typography;


const ModalPopBallon = ({ isOpen, onCancel }) => {
  const dispatch = useDispatch();

  const [showTerms, setShowTerms] = useState(false);
  const [acceptCheckBox, setAcceptCheckBox] = useState(false);
  const [modalWidth, setModalWidth] = useState(560);
  const imageUrl = "https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/BallonAnimation/aniversario/banner-termo.png";


  const handleRedirectToTerms = () => {
    setShowTerms(true);
    setModalWidth("95%");
  };

  const handleCheckBox = (e) => {
    setAcceptCheckBox(e.target.checked);
  };

  const ModalFooter = () => {
    return (
      <>
        <div className="container-checkbox">
          <Checkbox
            checked={acceptCheckBox}
            onChange={handleCheckBox}
            className="checkbox-terms"
          />
          <span>
            Eu li e Aceito os
            <a className="txt-terms" onClick={handleRedirectToTerms}>
              {" "}
              Termos {" "}
            </a>
            da Campanha
          </span>
        </div>

        {
          acceptCheckBox && (
            <VertButton
              type="highlight"
              className="btn-accept"
              onClick={() => dispatch(signTerm())}>
              Li e Aceito os Termos da Campanha
            </VertButton>
          )
        }

      </>
    )
  }


  return (
    <Modal
      key={"ModalTermOfUse"}
      open={isOpen}
      className="modal-terms-of-use"
      onCancel={() => onCancel()}
      onOk={() => onCancel()}
      width={modalWidth}
      footer={<LegalText />}
    >
      <div className="modal-terms-of-use-content">
        {showTerms ? (
          <>
            <Paragraph>
              <div
                className="icon-show-terms"
                onClick={() => { setShowTerms(false), setModalWidth(560); }}
              >
                <LeftOutlined alt="Voltar" />
                <span> Voltar </span>
              </div>
            </Paragraph>
            <Terms />
          </>
        ) : (
          <>
            <Paragraph className="title">Termos do Regulamento</Paragraph>
            <div className="banner-container">
              <img src={imageUrl} alt="Campanha" />
            </div>
          </>
        )}
        < ModalFooter />

      </div>
    </Modal >
  );
};

ModalPopBallon.propTypes = {
  open: PropTypes.bool,
  acceptTerms: PropTypes.func,
  cancelTerm: PropTypes.func,
  onStateModal: PropTypes.func,
  terms: PropTypes.shape({
    vendorId: PropTypes.number,
    type: PropTypes.string,
  }),
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  imageUrl: PropTypes.string,
};

export default ModalPopBallon;
